import { Injectable, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { HttpResponse } from 'selenium-webdriver/http';
import 'rxjs/add/operator/switchMap';
import { environment } from 'environments/environment';
import { DayAllocationInfo, KerAllocation } from 'app/ngs-types/day-allocation-info';
import { MatYearView } from '@angular/material';
import { map } from 'rxjs/operators';
// declare var gapi: any;

@Injectable()
export class GoogleApiService {

    rootUrl = environment.ROOT + '/_ah/api/ngsAlpha/v2/';


    constructor(public authService: AuthService, private http: HttpClient) {
    }

    getUploadUrl(): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'uploadUrl.get', {});
            });
    }


    uploadNgsJobLog(ngsPod: string, atado: string, newKer: string, oldKer: string,
        meroAllas: string, newMeroAllas:string, logType: string, comments: string, closures:string, selectedDate:any, myFile: File): Observable<any> {
        const self = this;
        return this.getUploadUrl().switchMap(
            uploadUrl => {
                console.log(uploadUrl.properties.url);
                const body = new FormData();
                body.append('ngsPod', ngsPod);
                body.append('atado', atado);
                body.append('newKer', newKer);
                body.append('oldKer', oldKer);
                body.append('meroAllas', meroAllas);
                body.append('newMeroAllas', newMeroAllas);
                body.append('logType', logType);
                body.append('comments', comments);
                body.append('closures', closures);
                body.append('myFile', myFile);
                body.append('eventDate', selectedDate);
                return this.http.post(uploadUrl.properties.url, body);
            }
        );

    }

    //Consumer queries
    getConsumers(atadoId: string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'consumer.list', { atado: atadoId });

            });
    }

    getConsumerByNgsPod(pod: string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'consumer', { ngsPod: pod });

            });
    }

    saveConsumer(pod: string, properties: any): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, 'consumer.save', { ngsPod: pod }, properties);
            }
        );
    }

    //NgsJobLogs

    getJobLogs(pod: string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'general.list', { entity: 'NgsJobLogs', filterKey: 'ngsPod', filterValue: pod });

            });
    }


    getJobLogsOfAtado(atado:string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'general.list', { entity: 'NgsJobLogs', filterKey:'atado', filterValue: atado });

            }
        );
    }

    getAllokaciok(atado:string, year:number, month:number, isKwh:boolean): Observable<any> {
        var entityName = atado + "_";
        if(isKwh){
            entityName += "allokaciok_kwh";
        }
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'general.list', { entity: entityName, filterKey:'date', filterValue: year + '_' + month });
            }
        );
    }

    saveDayAllocation(atado_:string, kereskedo_:string, year_: Number, month_: Number, pod_:string, day_:number, allok_kwh:number): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, 'pod_allocation.save', { atado:atado_, kereskedo:kereskedo_, year:year_, month:month_, day:day_, pod:pod_, allok:allok_kwh},null);
            }
        );
    }

    saveKerDailyAllocation(allocInfo: DayAllocationInfo): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, 'daily_allocation.save', 
                { atado:allocInfo.atado, 
                  year:allocInfo.date.getFullYear(),
                  month:allocInfo.date.getMonth()+1,
                  day:allocInfo.date.getDate(),
                  cv_m3:allocInfo.m3,
                  TU:allocInfo.TU,
                  PB:allocInfo.PB,
                  mj_kwh_teny:allocInfo.kwh_teny,
                  q: allocInfo.Q,
                  allokaciok: JSON.stringify(allocInfo.convertMapToAllocation(allocInfo.allocation))}, null);
            }
        );
    }

    getDayAllocations(atado: string, year:number, month:number): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'day_allocation.list', { atado: atado, year: year, month: month });
            });
    }

    getDayAllocationsParsed(atado: string, year:number, month:number) {
        const getItemProperties = map(value => {
            return value['items'].map(elem => {
                const prop_dict = elem['properties'];
                prop_dict['name'] = elem['key']['name'];
                const alloks = [];
                const allokaciok = JSON.parse(elem['properties']['allokaciok']);
                prop_dict['allokaciok'] = allokaciok;
                return prop_dict;
                }
            );
        });
        return this.getDayAllocations(atado, year, month).pipe(getItemProperties);
    }

    getKerDerivedData(atado:string, year:number, month:number){
        
        const getKerMonthlySumPipe = map((elem:Array<any>)=>{
            const dailyKerAmount: Map<number, Map<string,number>> = new Map<number, Map<string,number>>();
            const allAllok = [];
            elem.forEach(dailyAllok => {
                const day = parseInt(dailyAllok.day);
                const dailyMap = new Map<string,number>();
                dailyAllok.allokaciok.forEach(allokacio => {
                    allAllok.push(allokacio);
                    dailyMap.set(allokacio.szallittato_par_kod, allokacio.kwh);
                });
                dailyKerAmount.set(day, dailyMap);
            });
            const kerMonthlySum:Array<any> = allAllok.reduce((acc, item) => {
  
                let accItem = acc.find(ai => ai.szallittato_par_kod === item.szallittato_par_kod)
                if(accItem){
                    accItem.kwh += item.kwh 
                }else{
                   acc.push(item)
                }
              
                return acc;
              },[])
              const kerSumMap:Map<string, number> = new Map<string, number>();
              kerMonthlySum.forEach(elem=>{
                kerSumMap.set(elem.szallittato_par_kod,elem.kwh);
              });
              return [dailyKerAmount, kerSumMap];
        });
        return this.getDayAllocationsParsed(atado, year, month).pipe(getKerMonthlySumPipe);
        
    }

    saveLekotes(pod:string, pod_kieg:string, kezdete:number, vege:number, kapacitas:number, tipus:string, id:number, state:string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, 'lekotes.save', { pod: pod,
                                                                         pod_kieg: pod_kieg,
                                                                           kezdete: kezdete,
                                                                           vege: vege,
                                                                           kapacitas: kapacitas,
                                                                           tipus: tipus, 
                                                                           id: id,
                                                                           state:state}, null);
            }
        );
    }

    saveVasarolt(pod:string, pod_kieg:string, kezdete:number, vege:number, mennyiseg:number, ref:string, state:string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, 'vasarolt.save', { pod: pod,
                                                                          pod_kieg: pod_kieg,
                                                                         kezdete: kezdete,
                                                                         vege: vege,
                                                                         mennyiseg: mennyiseg,
                                                                         ref: ref,
                                                                         state: state}, null);
            }
        );
    }

    getAllowances(ettol:number, eddig:number, allowanceType: string): Observable<any> {
        const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createGetRequest(idToken, 'allowance.list', { allowanceType: allowanceType, ettol: ettol, eddig: eddig });
            });
    }


   genericSaveData(endpoint:string, payload:any){
       const self = this;
        return this.authService.getUserIdToken().switchMap(
            idToken => {
                return self.createPostRequest(idToken, endpoint, payload, null);
            }
        );
   }

   genericGetData(endpoint:string, payload:any): Observable<any> {
    const self = this;
    return this.authService.getUserIdToken().switchMap(
        idToken => {
            return self.createGetRequest(idToken, endpoint, payload);
        });
}
    
   private createPostRequest(userToken: string, path: string, routeParams, body): Observable<HttpResponse> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userToken
            }),
            params: routeParams
        };
        const url = this.rootUrl + path;
        return this.http.post(url, body, httpOptions);
    }

    private createGetRequest(userToken: string, path: string, routeParams): Observable<HttpResponse> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userToken
            }),
            params: routeParams
        };
        const url = this.rootUrl + path;
        return this.http.get(url, httpOptions);
    }
}



// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/service/google-api.service.ts